import { parseNumericIdFromShopifyId } from "@redotech/shopify-util/id";

export function shopifyStoreName(storeDomain: string) {
  return storeDomain.replace(/\.myshopify\.com$/, "");
}

const shopifyAdminUrl = new URL("https://admin.shopify.com");

function shopifyAdminStoreUrl(storeName: string): URL {
  return new URL(`store/${encodeURIComponent(storeName)}`, shopifyAdminUrl);
}

export function shopifyAdminProductUrl(
  storeName: string,
  productId: string,
  variantId?: string,
): URL {
  return new URL(
    `products/${encodeURIComponent(productId)}` +
      (variantId ? `/variants/${variantId}` : ""),
    shopifyAdminStoreUrl(storeName) + "/",
  );
}

export function shopifyAdminLocationUrl(
  storeName: string,
  locationId: string,
): URL {
  return new URL(
    `settings/locations/${encodeURIComponent(parseNumericIdFromShopifyId(locationId))}`,
    shopifyAdminStoreUrl(storeName) + "/",
  );
}

export function shopifyAdminOrderUrl(storeName: string, orderId: string): URL {
  return new URL(
    `orders/${encodeURIComponent(orderId)}`,
    shopifyAdminStoreUrl(storeName) + "/",
  );
}

export function shopifyAdminDraftOrderUrl(
  storeName: string,
  draftOrderId: string,
): URL {
  return new URL(
    `draft_orders/${encodeURIComponent(draftOrderId)}`,
    shopifyAdminStoreUrl(storeName) + "/",
  );
}

const numericIdRegex = /^\d+$/;
const shopifyDiscountCodeNodeGidRegex =
  /^gid:\/\/shopify\/DiscountCodeNode\/\d+$/;

function parseShopifyAdminDiscountNumericId(
  discountId: string,
): string | undefined {
  if (
    !numericIdRegex.test(discountId) &&
    !shopifyDiscountCodeNodeGidRegex.test(discountId)
  ) {
    return undefined;
  }
  const numericId = parseNumericIdFromShopifyId(discountId);
  return numericIdRegex.test(numericId) ? numericId : undefined;
}

export function shopifyAdminDiscountUrl(
  storeName: string,
  discountId: string,
): URL | undefined {
  const numericId = parseShopifyAdminDiscountNumericId(discountId);
  if (!numericId) {
    return undefined;
  }
  return new URL(
    `discounts/${encodeURIComponent(numericId)}`,
    shopifyAdminStoreUrl(storeName) + "/",
  );
}
